import React from 'react'

const Error = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <h2>404 | Page not found!</h2>
        </div>
    )
}

export default Error
